import {
    CancelFlightsActionTypes,
    FlightsByFlightNumberState,
    GET_FLIGHTS_BY_FLIGHT_NUMBER_SUCCESS,
    GET_FLIGHTS_BY_FLIGHT_NUMBER_FAILURE,
    GET_FLIGHTS_BY_FLIGHT_NUMBER_CLEAR,
    CANCEL_FLIGHT_REQUEST_SUCCESS,
    CANCEL_FLIGHT_REQUEST_FAILURE,
    CANCEL_FLIGHT_REQUEST_CLEAR,
    CancelFlightRequestState
} from './types';

const flightsByFlightNuberInitState: FlightsByFlightNumberState = {
    data: {
        rpl: null,
        id: ''
    }
}

export function flightsByFlightNumber(state = flightsByFlightNuberInitState, action: CancelFlightsActionTypes) {
    switch (action.type) {
        case GET_FLIGHTS_BY_FLIGHT_NUMBER_SUCCESS:
            return action.payload;
        case GET_FLIGHTS_BY_FLIGHT_NUMBER_FAILURE:
            return action.payload;
        case GET_FLIGHTS_BY_FLIGHT_NUMBER_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

const cancelFlightRequestInitState: CancelFlightRequestState = {
    data: {
        result: false
    }
}
export function cancelFlightRequest(state = cancelFlightRequestInitState, action: CancelFlightsActionTypes) {
    switch (action.type) {
        case CANCEL_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case CANCEL_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case CANCEL_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}